// extracted by mini-css-extract-plugin
export default {"list":"ServiceMenu_list__6VyeR","item":"ServiceMenu_item__trYzS","link":"ServiceMenu_link__S07pG","isActive":"ServiceMenu_isActive__nmYty"};